import PropTypes from 'prop-types'

export default function H6TitleLeftAlign({ title, className, ...props }) {
  return (
    <h6 className={`text-left ${className ? className :''}`} {...props}>{title}</h6>
  )
}

H6TitleLeftAlign.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
}